import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-527e4d06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "recent"
}
const _hoisted_2 = { class: "block__title" }

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import CarouselCards from '@/components/Carousel/CarouselCards.vue';
import { LabData } from '@/types/LabData';


export default /*#__PURE__*/_defineComponent({
  __name: 'Recent',
  props: {
    products: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const recentId = computed(() => store.getters['Common/recent']);
const recent = computed(
  () => {
    const list: LabData[] = [];
    recentId.value.forEach((id: string) => {
      const item = props.products.find((item) => String(item.id) === String(id));
      if (item) {
        list.push(item);
      }
    });
    return list;
  }
);

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (recent.value && recent.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)("labs.recent")), 1),
        _createVNode(CarouselCards, {
          class: "recent__carousel",
          list: recent.value
        }, null, 8, ["list"])
      ]))
    : _createCommentVNode("", true)
}
}

})